export enum AI_GENERATE_TYPE {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
}

export enum AI_GENERATION_STAGE {
  PROMPT_INPUT = 'PROMPT_INPUT',
  CREDITS_CHECK = 'CREDITS_CHECK',
  GENERATING = 'GENERATING',
  CANCEL_CONFIRMATION = 'CANCEL_CONFIRMATION',
  VIDEO_PREVIEW = 'VIDEO_PREVIEW',
  ERROR = 'ERROR',
}

export enum UploadTypes {
  Audio = 'Audio',
  Video = 'Video',
  Image = 'Image',
}

export enum AIMediaStatus {
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  Success = 'Success',
  Error = 'Error',
  InQueue = 'InQueue',
}

export interface AIMedia {
  id: string;
  userId: string;
  name: string;
  type: UploadTypes;
  thumbnailUrl: string;
  status: AIMediaStatus;
  prompt: string;
  duration: number | null;
  url: string;
  progress: number;
  thirdPartyId: string | null;
  errorMessage: string | null;
  createdAt?: string;
  updatedAt?: string;
}
